import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { ErreurApi } from './api/client';
import { FournisseurNotifications } from './components/Notifications';
import './styles/app.css';

/**
 * Politique de reprise : on ne réessaie JAMAIS une erreur métier (4xx). Rejouer un 403 ou un
 * 404 trois fois de suite ne fait que retarder l'affichage du message et charger l'API. Seules
 * les pannes de transport et les 5xx méritent une seconde chance.
 */
const clientRequetes = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (tentative, erreur) => {
        if (erreur instanceof ErreurApi && erreur.http >= 400 && erreur.http < 500) return false;
        return tentative < 2;
      },
      retryDelay: (tentative) => Math.min(1000 * 2 ** tentative, 8000),
      refetchOnWindowFocus: true,
      staleTime: 15_000,
      gcTime: 5 * 60_000,
    },
    mutations: {
      retry: false,
    },
  },
});

const racine = document.getElementById('racine');
if (!racine) throw new Error('Élément #racine introuvable dans index.html.');

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={clientRequetes}>
      <BrowserRouter>
        <FournisseurNotifications>
          <App />
        </FournisseurNotifications>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
